module.exports = __webpack_public_path__ + "img/zhengshu104.c00d88d0.jpg";